(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var resourceUrl = 'security/' + 'api/platform-users/changePassword/:id';
        return $resource(resourceUrl, {}, {
            'save': { method:'POST' }
        });
    }
})();
